/**
 * Pick the locale-appropriate display label for a category.
 *
 * Categories carry both `name` (English) and `name_zh` (Chinese, nullable).
 * For zh locale, prefer the Chinese name when present; fall back to English
 * if the Chinese is missing for any reason. For en (or any other) locale,
 * always show the English name.
 */
export function localizedCategoryName(
  cat: { name: string; name_zh: string | null },
  locale: string,
): string {
  return locale === 'zh' && cat.name_zh ? cat.name_zh : cat.name;
}
